<template>
  <MRow :gutter="0">
    <MCol :lg="12" :sm="12" auto-size>
      <MRow :gutter="0">
        <MCol :size="6" class="pr-2">
          <FlotoFormItem
            v-model="formData.invoiceNumber"
            :disabled="disabled"
            :placeholder="__t('invoice_number')"
            rules="required|short_text"
            :label="__t('invoice_number')"
          />
        </MCol>

        <MCol :size="6" class="pl-2">
          <FlotoFormItem
            :disabled="disabled"
            :placeholder="__t('bill_date')"
            rules="required"
            :label="__t('bill_date')"
          >
            <FlotoDatePicker
              v-model="formData.billDate"
              :placeholder="$t('select')"
            />
          </FlotoFormItem>
        </MCol>
        <MCol :size="6" class="pr-2">
          <FlotoFormItem
            v-model="formData.amount"
            :disabled="disabled"
            :placeholder="__t('invoice_amount')"
            type="number"
          >
            <template v-slot:label>
              <span class="flex text-neutral">
                {{ __t('invoice_amount') }}
                (<CurrencyPicker
                  :value="currencyId"
                  text-only
                  disabled
                  style="white-space: nowrap"
                />)
              </span>
            </template>
          </FlotoFormItem>
        </MCol>
        <MCol :size="6" class="pl-2">
          <FlotoFormItem
            :disabled="disabled"
            :placeholder="__t('due_date')"
            rules="required"
            :label="__t('due_date')"
          >
            <FlotoDatePicker
              v-model="formData.dueDate"
              :placeholder="$t('select')"
            />
          </FlotoFormItem>
        </MCol>
        <MCol :size="12">
          <FlotoFormItem
            v-model="formData.description"
            :disabled="disabled"
            :placeholder="__t('comments')"
            :label="__t('comments')"
            :rows="2"
            type="textarea"
          />
        </MCol>
        <MCol :size="6" class="pl-2">
          <FlotoFormItem :label="$tc('attachment')">
            <FlotoAttachment
              v-model="formData.fileAttachments"
              :max-files="1"
            />
          </FlotoFormItem>
        </MCol>
      </MRow>
    </MCol>
  </MRow>
</template>

<script>
import CurrencyPicker from '@components/data-picker/currency-picker'
export default {
  name: 'InvoiceForm',
  components: { CurrencyPicker },
  props: {
    formData: { type: Object, required: true },
    currencyId: { type: Number, default: undefined },
  },
  computed: {
    disabled() {
      if (this.formData.id && !this.formData.canEdit) {
        return true
      }
      return false
    },
  },
}
</script>
